import React from 'react';

export const formatDateTime = (datetimeString, timezone) => {
  if (!datetimeString) {
    return 'N/A';
  }

  try {
    // Step 1: Parse the UTC timestamp correctly
    let utcDate;

    if (typeof datetimeString === 'string') {
      // Handle the specific format with space instead of T
      if (
        datetimeString.includes(' ') &&
        (datetimeString.includes('+') || datetimeString.includes('Z'))
      ) {
        // Replace space with T to make it proper ISO 8601
        const isoString = datetimeString.replace(' ', 'T');
        utcDate = new Date(isoString);
      }
      // Handle format like "2025-05-19 23:54:06.417308+00:00"
      else if (datetimeString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/)) {
        // Extract date and time parts, and explicitly treat as UTC
        const [datePart, timePart] = datetimeString.split(' ');
        // Remove any milliseconds and timezone info
        const timePortion = timePart.split(/[.+-]/)[0];
        const isoString = `${datePart}T${timePortion}Z`;
        utcDate = new Date(isoString);
      } else {
        // Regular date string, ensure it's treated as UTC if no timezone info
        utcDate =
          datetimeString.includes('Z') ||
          datetimeString.includes('+') ||
          datetimeString.includes('-')
            ? new Date(datetimeString)
            : new Date(`${datetimeString}Z`);
      }
    } else {
      utcDate = new Date(datetimeString);
    }

    // Check if we have a valid date
    if (isNaN(utcDate.getTime())) {
      console.error(`Invalid date: ${datetimeString}`);
      return 'N/A';
    }

    // Step 2: Format using the user's timezone or default browser timezone
    const userTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Format the date with the specified timezone
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: userTimezone,
      timeZoneName: 'short'
    }).format(utcDate);
  } catch (error) {
    console.error('Error formatting date:', error, datetimeString);
    return 'N/A';
  }
};

export const DueTimeDisplayTable = ({ datetimeString, timezone }) => {
  // Skip processing if no date is provided
  if (!datetimeString) {
    return <div>N/A</div>;
  }

  const formattedDateTime = formatDateTime(datetimeString, timezone);

  return <div>{formattedDateTime}</div>;
};
